import { createStore } from "solid-js/store";

export type ModifiedRecord = {
	modifiedAt: string;
};

interface CacheStoreType {
	cache: Record<string, ModifiedRecord & any>;
}

export const [recordCacheStore, setRecordCacheStore] = createStore<CacheStoreType>(
	{ cache: {} },
	{ name: "CacheStore" },
);
